// extracted by mini-css-extract-plugin
export default {"quantity_wrapper":"UV","increment":"VV","decrement":"WV","product":"XV","product_info":"YV","text":"ZV","modify_btn":"aW","controls":"bW","price":"cW","deliveredOnce":"eW"};
    if(module.hot) {
      // 1711717534777
      var cssReload = require("../../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  